import theme from '@/theme';

interface MaspLogoProps {
  color?: string;
  size?: number;
}

export default function MaspLogo({ color = theme.colors.primary.DEFAULT, size = 20 }: MaspLogoProps) {
  return (
    <svg
      height={size}
      width={(259 / 70) * size}
      viewBox='0 0 197 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'>
      <path
        d='M0 51.0384V0.958984H20.9313L29.1749 33.2568H29.5612L37.8048 0.958984H58.6069V51.0384H45.0821V17.0115H44.6958L35.8075 51.0384H22.3472L13.2665 17.0115H12.8802V51.0384H0Z'
        fill='#E30613'
      />
      <path
        d='M60.0413 51.0384L77.6886 0.958984H93.6603L111.306 51.0384H96.8797L94.2391 42.4635H77.1072L74.4666 51.0384H60.04H60.0413ZM79.9417 31.8297H91.406L85.8676 14.6107H85.4813L79.943 31.8297H79.9417Z'
        fill='#E30613'
      />
      <path
        d='M130.747 51.9987C118.033 51.9987 108.989 44.6581 108.203 34.1626H123.079C123.211 38.5531 126.291 41.3662 130.813 41.3662C134.613 41.3662 137.17 39.4456 137.17 36.2893C137.17 34.0256 135.793 32.9961 131.927 32.516L127.929 32.0358C115.281 30.5262 109.645 25.3124 109.645 16.6696C109.645 6.79128 118.1 0 130.486 0C142.871 0 151.653 6.92828 151.849 17.0128H136.777C136.711 13.0333 134.22 10.6325 130.354 10.6325C127.078 10.6325 124.784 12.3469 124.784 15.0922C124.784 17.4251 126.422 18.5224 130.157 19.0026L134.09 19.4827C146.345 20.9923 152.112 25.9308 152.112 34.5071C152.112 45.0026 143.134 52 130.748 52L130.747 51.9987Z'
        fill='#E30613'
      />
      <path
        d='M154.904 51.0384V0.958984H177.93C189.791 0.958984 197 7.13312 197 18.2471C197 29.3611 189.661 36.2894 178.061 36.2894H169.321V51.0384H154.904ZM169.321 25.9987H175.047C179.372 25.9987 182.256 23.5288 182.256 18.7951C182.256 14.0614 179.635 11.5915 175.047 11.5915H169.321V25.9974V25.9987Z'
        fill='#E30613'
      />
    </svg>
  );
}
